import React from 'react'
import { connect } from 'react-redux'

import BurgerMenu from '../burger/BurgerMenu'
import { AlertsBell } from '../alerts/AlertsBell'
import { authSelector } from '../../store/slices/auth'
import {
    FixedTopbar,
    GlobalStyle,
    Page,
    StyledTitle,
    TopbarUsername,
} from '../scharedStyles/style'

const mapStateToProps = (state) => ({
    username: authSelector.username(state),
    authLoading: authSelector.isLoading(state),
    isAuthorized: authSelector.isAuthorized(state),
    authError: authSelector.error(state),
})

const AppShell = ({
    title,
    children,
    username,
    authLoading,
    isAuthorized,
    authError,
}) => {
    if (authLoading) {
        return <div className="db-loading-page">Проверка авторизации...</div>
    }

    if (!isAuthorized) {
        return (
            <div className="page">
                <div className="error-box">
                    {authError || 'Пользователь не авторизован'}
                </div>
            </div>
        )
    }

    return (
        <>
            <GlobalStyle />
            <Page>
                <FixedTopbar>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <BurgerMenu />
                    </div>
                    <StyledTitle style={{ textAlign: 'center' }}>{title}</StyledTitle>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        justifyContent: 'flex-end',
                    }}
                    >
                        <AlertsBell />
                        <TopbarUsername>{username}</TopbarUsername>
                    </div>
                </FixedTopbar>
                {children}
            </Page>
        </>
    )
}

export default connect(mapStateToProps)(AppShell)
